import * as React from "react";
const SvgFlux = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props
  },
  /* @__PURE__ */ React.createElement("rect", { width: 20, height: 20, fill: "black" }),
  /* @__PURE__ */ React.createElement("g", { clipPath: "url(#clip0_4312_133911)" }, /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M8.83333 18.5H4.16667V15.8167L3 14.4167L4.94444 12.6667L3 10.9167L4.94444 9.16667L3 7.41667L5.02222 5.60833L4.16667 4.73333V1H17V5.08333H8.83333V7.41667H16.4167V11.5H8.83333V18.5ZM5.33333 17.3333H7.66667V10.3333H15.25V8.58333H7.66667V3.91667H15.8333V2.16667H5.33333V4.26667L6.81111 5.74444L4.75 7.41667L6.88889 9.16667L4.75 10.9167L6.88889 12.6667L4.75 14.4167L5.33333 15.35V17.3333Z",
      fill: "#1DFDC0"
    }
  )),
  /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement("clipPath", { id: "clip0_4312_133911" }, /* @__PURE__ */ React.createElement("rect", { width: 14, height: 17.5, fill: "white", transform: "translate(3 1)" })))
);
export default SvgFlux;
